import { useState } from "react";

import type { CartLoadMetadata } from "@cart-client/analytics/events/CartLoad";

function snapshotCartLoadMetadata(): CartLoadMetadata | null {
    if (typeof window === "undefined") {
        return null;
    }

    const headers = window.__headers__;
    const prefetchEnabled = headers?.cartpageprefetch === "true";

    const cartApiData = window.cartApiData;
    const source = cartApiData?.source === "prefetch" ? "prefetch" : "bau";
    // Gated on source === "prefetch" because __prefetchBridgeUsed__ is sticky (set once,
    // never cleared) while cartApiData.source IS cleared by useFetchCart after consumption.
    // Without the gate, back-navigation remounts would report bridge_used:true / source:"bau".
    const prefetchBridgeUsed = window.__prefetchBridgeUsed__ === "true" && cartApiData?.source === "prefetch";
    const bgRefreshNeeded = !!cartApiData?.needsBackgroundRefresh;
    const bgRefreshReason = cartApiData?.backgroundRefreshReason ?? null;
    const hasActiveTimers = !!cartApiData?.hasActiveTimers;

    const prefetchTimestampRaw = cartApiData?.prefetchTimestamp;
    const prefetchTimestampParsed = prefetchTimestampRaw ? parseInt(prefetchTimestampRaw, 10) : NaN;
    const prefetchTimestamp = Number.isFinite(prefetchTimestampParsed) ? prefetchTimestampParsed : null;

    const cacheTtlMs = typeof cartApiData?.cacheTtlMs === "number" ? cartApiData.cacheTtlMs : null;

    const prefetchFallbackReason = window.__prefetchFallbackReason__ ?? null;
    const isRemount = window.__cartImpressionFired__ === "true";

    return {
        prefetchEnabled,
        prefetchBridgeUsed,
        source,
        bgRefreshNeeded,
        bgRefreshReason,
        isRemount,
        prefetchFallbackReason,
        hasActiveTimers,
        prefetchTimestamp,
        cacheTtlMs,
    };
}

const useCartLoadImpression = (): CartLoadMetadata | null => {
    const [metadata] = useState<CartLoadMetadata | null>(() => snapshotCartLoadMetadata());
    return metadata;
};

export default useCartLoadImpression;
